export enum Cultures {
  tr_TR = 1,
  en_US = 2,
  de_DE = 3,
  fr_FR = 4,
  it_IT = 5,
  es_ES = 6,
  ar_SA = 7,
  ru_RU = 8
}

export enum AuthOperation {
  View = 1,
  Save = 2,
  Delete = 3
}

export enum AuthPermission {
  Journal = 1,
  Issue = 2,
  Article = 3
}

export enum RoleGroups {
  Author = 1,
  Editor = 2,
  Member = 3,
  Reviewer = 4,
  Reader = 5
}

export enum ContentGroups {
  ArticlesTab = 2
}

export enum SimpleUIGroup {
  SocialMenu = 1,
  Menu = 2
}

export enum EnvironmentType {
  Development,
  Test,
  Production
}

export enum SearchScope {
  All = 0,
  Title = 1,
  Abstract = 2,
  Keywords = 3,
  Author = 4,
  DOI = 5,
  FullText = 6
}

export enum SearchOperator {
  AND = 0,
  OR = 1,
  NOT = 2
}

export enum SortOption {
  Relevance = 0,
  PublishDate = 1,
  Title = 2,
  Citations = 3,
  Views = 4
}

export enum SortDirection {
  ASC = 0,
  DESC = 1
}

export enum ContentType {
  All = 0,
  Article = 1,
  Book = 2,
  Journal = 3,
  Author = 4
}

export interface PaginationInfo {
  Page: number;
  Take: number;
}

export interface AdvancedSearchRequestDTO {
  // Temel Arama
  SearchTerm?: string;
  Scope?: SearchScope;

  // Çoklu Alan Araması (IEEE tarzı)
  TitleSearch?: string;
  AbstractSearch?: string;
  KeywordSearch?: string;
  AuthorSearch?: string;
  DOISearch?: string;
  AffiliationSearch?: string;

  // Boolean Operatörler
  Operator?: SearchOperator;

  // Filtreler
  JournalIDs?: number[];
  BookIDs?: number[];
  SubjectIDs?: number[];
  IndexIDs?: number[];
  SectionIDs?: number[];
  ClassificationIDs?: number[];
  LanguageIDs?: number[];

  // Tarih Filtreleri
  PublishDateFrom?: Date;
  PublishDateTo?: Date;
  YearFrom?: number | null;
  YearTo?: number | null;

  // Sayfa Filtreleri
  PageFrom?: number;
  PageTo?: number;

  // Sıralama
  SortBy?: SortOption;
  SortDirection?: SortDirection;

  // Sayfalama
  Page: number;
  Take: number;

  // İçerik Tipi
  ContentTypes?: ContentType[];
  Pagination?: { [key: number]: PaginationInfo };

  // Gelişmiş Çoklu Alan Araması
  SearchFields?: SearchFieldDTO[];
}

export interface SearchFieldDTO {
  Text: string;
  Scope: SearchScope;
  Operator: SearchOperator;
}

export interface SearchResultItemDTO {
  ID: number;
  Type: string;
  Title: string;
  Abstract?: string;
  Authors?: string[];
  Keywords?: string[];
  DOI?: string;
  ISBN?: string;
  EISBN?: string;
  Slug: string;
  JournalName?: string;
  JournalSlug?: string;
  BookName?: string;
  BookSlug?: string;
  Description?: string;
  PublishDate?: string;
  Year?: number;
  Volume?: number;
  Issue?: number;
  StartPage?: number;
  EndPage?: number;
  PdfUrl?: string;
  CoverImage?: string;
  RelevanceScore?: number;
  HighlightedSnippets?: string[];
  
  // Author-specific properties
  AuthorName?: string;
  AuthorTitle?: string;
  Email?: string;
  ISSN?: string;
  EISSN?: string;
  TotalArticles?: number;
  TotalBooks?: number;
  TotalChapters?: number;
  TotalSeries?: number;
  TotalPublications?: number;
}

export interface SearchSubMetadataDTO {
  ContentType: ContentType;
  TotalResults: number;
  Page: number;
  PageSize: number;
  TotalPages: number;
  SearchResultList: SearchResultItemDTO[];
}

export interface SearchMetadataDTO {
  TotalResults: number;
  SearchTime: number;
  Query: string;
}

export interface AdvancedSearchResponseDTO {
  Results: SearchSubMetadataDTO[];
  Metadata: SearchMetadataDTO;
  Facets?: any[];
}
